module.exports = __webpack_public_path__ + "img/thanks.f31b41f2.svg";